<template>
  <div class="w-full">
    
    <form class="bg-white shadow-md rounded px-4 pb-4 mb-2 sm:px-6 sm:pb-5" @submit.prevent="teste">
      <div id="select-action" class="grid grid-cols-2 bg-white mb-4">
        <div @click="nameAction = 'fields-login'" 
          id="login" 
          :class=" {'active': nameAction === 'fields-login'} "
          class="text-gray-300 hover:text-gray-800 cursor-pointer py-5 w-full">
            LOGIN
        </div>
        <div @click="nameAction = 'fields-register'" 
          id="register" 
          :class="{'active': nameAction === 'fields-register'}"
          class="text-gray-300 hover:text-gray-800 cursor-pointer py-5 w-full">
            REGISTER
        </div>
      </div>
      
      <transition name="component-fade" mode="out-in">
        <component v-bind:is="nameAction"></component>
      </transition>
    
      
      <div class="flex flex-col w-2/3 m-auto">
        <p class="text-gray-500 my-4">Or sign in using social media</p>
        <div class="flex item-center justify-around my-4">
          <font-awesome-icon class="text-blue-400 hover:text-blue-700" :icon="['fab','facebook-square']" size="2x"/>
          <font-awesome-icon class="text-red-400 hover:text-red-700" :icon="['fab','google']" size="2x"/>
        </div>
      </div>
    </form>
    <p class="text-center text-gray-300 text-xs">
      &copy;2020 JCPurger Corp. All rights reserved.
    </p>
  </div>
</template>

<script>
import FieldsLogin from "@/components/AuthCards/FieldsLogin.vue"
import FieldsRegister from "@/components/AuthCards/FieldsRegister.vue"

export default {
  name: 'CardLoginRegister',
  components: {
    'fields-login': FieldsLogin,
    'fields-register': FieldsRegister,
  },
  data: function () {
    return {
      nameAction: "fields-login"
    }
  }
}
</script>

<style lang="scss">
#select-action .active {
  color: black;
  font-weight: 600;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .1s ease;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: .5;
}
</style>